"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const RewardedIcon = () => /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 889"
}, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  d: "M248.067 750.045c-1.806.14-3.835.111-5.696.64-14.838 4.17-23.285 20.015-19.062 34.804 4.168 14.789 19.45 23.184 34.316 18.987a27.51 27.51 0 0016.669-13.114 27.532 27.532 0 002.393-21.08c-3.504-12.701-15.484-21.161-28.62-20.21v-.027zM27.777 87.247v714.394c0 32.728 23.445 59.47 52.297 59.47h339.852c28.963 0 52.296-26.515 52.296-59.47V87.247c0-32.727-23.444-59.47-52.296-59.47H80.074c-28.963 0-52.296 26.516-52.296 59.47zM0 88.89C0 39.815 35.143 0 78.929 0H421.07C464.643 0 500 39.926 500 88.889V800c0 49.074-35.143 88.889-78.929 88.889H78.93C35.357 888.889 0 848.963 0 800V88.889zm27.778 577.778h444.444v27.777H27.778v-27.777zM333.333 375L166.667 500V250l166.666 125z"
}));

var _default = RewardedIcon;
exports.default = _default;